export default "__VITE_ASSET__C5iWF9Wr__"